import { render } from "./VetCustomerList.vue?vue&type=template&id=8b164358&scoped=true"
import script from "./VetCustomerList.vue?vue&type=script&lang=js"
export * from "./VetCustomerList.vue?vue&type=script&lang=js"

import "./VetCustomerList.vue?vue&type=style&index=0&id=8b164358&lang=css&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b164358"]])

export default __exports__